import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {LoginRedirectComponent} from './login-redirect.component';

const routes: Routes = [
    {
        path: ':url',
        component: LoginRedirectComponent
    }
];

@NgModule({
    declarations: [],
    imports: [
        RouterModule.forChild(routes),
    ],
    providers: []
})
export class LoginRedirectModule {
}
